import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

// components
import MomtheraPatientDataSidebar from '../../../components/momthera/patientDetail/MomtheraPatientDataSidebar';
import MomtheraPatientReport from '../../../components/momthera/patientDetail/MomtheraPatientReport';
import CommonModal from '../../../components/modal/CommonModal';

// api
import { getPatientFromMomthera, putPatientToMomthera } from '../../../services/apis/momthera/patient';
import { getMessagesTemplateFromMomthera, postMessageToMomthera } from '../../../services/apis/momthera/message';
import { getEmotionRecordsFromMomthera } from '../../../services/apis/momthera/emotion';
import { getSurveyAnxietyResultFromMomthera, getSurveyDepressionResultFromMomthera } from '../../../services/apis/momthera/survey';

function MomtheraPatientManageDetailPage() {
	const navigate = useNavigate();
	const { pid } = useParams();

	const [patientData, setPatientData] = useState({
		psctId: "",
		name: "",
		nickName: "",
		phoneNumber: "",
		birth: "",
		age: 0,
		psctCode: "",
		pregnantStatusCode: "",
		patientGroup: "",
		patientType: "",
		avataImage: "",
		studySession: 0,
		weekNum: 0,
		training: "",
		startDate: "",
		endDate: "",
		lastStudyDate: "",
		totalStudyTime: ""
	})

	const [emotionData, setEmotionData] = useState([]);

	const [depressionData, setDepressionData] = useState([]);
	const [anxietyData, setAnxietyData] = useState([]);
	

	// 환자 정보 조회 
	async function getPatienDataFromAPI() {
		try{
			const request = { pid };
			const res = await getPatientFromMomthera(request);
			if(parseInt(res.status/200,10)===1){
				const originalData = res.data[0];
				const newPatientData = {
					psctId: originalData.psctId || "",
					name:  originalData.name || "",
					nickName:  originalData.nickName || "",
					phoneNumber: originalData.phoneNumber || "",
					birth: originalData.birth || "",
					age: originalData.age || 0,
					psctCode: originalData.psctCode || "",
					pregnantStatusCode: originalData.pregnantStatusCode || "",
					patientGroup: originalData.patientGroup || "",
					patientType: originalData.patientType || "",
					avataImage: originalData.avataImage || "",
					studySession: originalData.studySession || 0,
					weekNum: originalData.weekNum || 0,
					training: originalData.training || "",
					startDate: originalData.startDate || "",
					endDate: originalData.endDate || "",
					lastStudyDate: originalData.lastStudyDate || "",
					totalStudyTime: originalData.totalStudyTime || ""
				}
				setPatientData(newPatientData);
			}else{
				throw new Error();
			}
		}catch(err){
			console.error(err);
			alert('환자 정보가 존재하지 않습니다.');
			navigate('/dtx006/patient-manage/list');
		}
	}


	// 수정 모달 ----------------------------
	const [newPatientType, setNewPatientType] = useState('');
	const [newPatientGroup, setNewPatientGroup] = useState("");
	const [newPatientDisplayName, setNewPatientDisplayName] = useState('');
	const [newPatientBirthYear, setNewPatientBirthYear] = useState(1990);
	const [newPatientBirthMonth, setNewPatientBirthMonth] = useState(10);
	const [newPatientBirthDay, setNewPatientBirthDay] = useState(20);

	// 환자 수정 modal
	const [showModifyPatientModal, setShowModifyPatientModal] = useState(false);

	// 신규 환자 추가 성공 modal
	const [showSuccessModifyPatient, setShowSuccessModifyPatient] = useState(false);

	function initializeModifyModal() {
		setNewPatientType(patientData.patientType);
		setNewPatientGroup(patientData.patientGroup);
		setNewPatientDisplayName(patientData.name);
		setNewPatientBirthYear(patientData.birth ? Number(patientData.birth.slice(0,4)) : 1990);
		setNewPatientBirthMonth(patientData.birth ? Number(patientData.birth.slice(4,6)) : 10);
		setNewPatientBirthDay(patientData.birth ? Number(patientData.birth.slice(6)) : 20);
	}

	const closeModifyPatientModal = () => {
		setShowModifyPatientModal(false);
		setNewPatientType(patientData.patientType);
		setNewPatientGroup(patientData.patientGroup);
		setNewPatientDisplayName(patientData.name);
		setNewPatientBirthMonth(patientData.birth ? Number(patientData.birth.slice(0,4)) : 1990);
		setNewPatientBirthMonth(patientData.birth ? Number(patientData.birth.slice(4,6)) : 10);
		setNewPatientBirthDay(patientData.birth ? Number(patientData.birth.slice(6)) : 20);
	}

	// 신규 환자 등록하는 function
	async function modifyPatient() {
		try{
			if (patientData.psctId && newPatientType && newPatientGroup && newPatientDisplayName) {
				const request = {
					psctId: patientData.psctId,
					name: newPatientDisplayName,
					birth:
						newPatientBirthYear.toString() +
						newPatientBirthMonth.toString().padStart(2, 0) +
						newPatientBirthDay.toString().padStart(2, 0),
					phoneNumber: patientData.phoneNumber,
					patientType: newPatientType,
					patientGroup: newPatientGroup
				};

				const res = await putPatientToMomthera(request);
				if(parseInt(res.status/200,10)===1){
					if(res.data==="FAIL"){
						throw new Error();
					}else{
						setShowSuccessModifyPatient(true);
					}
				}else{
					throw new Error();
				}
			} else {
				alert('환자 정보를 모두 입력해주세요.');
			}
		}catch(err){
			console.error(err);
			alert("환자 수정에 실패하였습니다.");
		}finally{
			closeModifyPatientModal();
		}
	}

	// 신규 환자 modal 생년월일 select option
	const birthYear = () => {
		const yearItems = [];
		for (let year = 1900; year <= new Date().getFullYear(); year++) {
			yearItems.push(
				<option key={year} value={year}>
					{year}
				</option>,
			);
		}
		return yearItems;
	};
	const birthMonth = () => {
		const monthItems = [];
		for (let month = 1; month <= 12; month++) {
			monthItems.push(
				<option key={month} value={month}>
					{month}
				</option>,
			);
		}
		return monthItems;
	};
	const birthDay = () => {
		const dayItems = [];
		const dateNum = new Date(newPatientBirthYear,newPatientBirthMonth,0).getDate();
		for (let day = 1; day <= dateNum; day++) {
			dayItems.push(
				<option key={day} value={day}>
					{day}
				</option>,
			);
		}
		return dayItems;
	};

	const ModifyPatientModalBody = (
		<div className="modalbody">
			<div className="formModalItem">
				<div className="formModalItem__label">구분</div>
				<div className="formModalItem__input">
					<select
						className="formModalItem__input__birth"
						onChange={e => {
							if((e.target.selectedOptions[0].value==='EC' || e.target.selectedOptions[0].value==='CC') && newPatientGroup==='COMMON') {
								setNewPatientGroup("");
							}else if(e.target.selectedOptions[0].value==='PR' && (newPatientGroup==='EXP' || newPatientGroup==='COMP')){
								setNewPatientGroup("");
							}
							setNewPatientType(e.target.selectedOptions[0].value)
						}}
						value={newPatientType}
					>
						<option key='EC' value='EC'>
							탐색임상
						</option>
						<option key='CC' value='CC'>
							확증임상
						</option>
						<option key='PR' value='PR'>
							처방
						</option>
					</select>
				</div>
			</div>
			<div className="formModalItem">
				<div className="formModalItem__label_large">환자군</div>
				<div className="formModalItem__input">
					<div className="formModalItem__input__radio formModalItem__input__radio_limit_width120">
						<input
							type="radio"
							id="실험군"
							value="EXP"
							name="patient-group"
							checked={newPatientGroup === 'EXP'}
							onChange={e => setNewPatientGroup(e.target.value)}
							disabled={newPatientType==='PR'}
						/>{' '}
						<label htmlFor="실험군" className="formModalItem__input__radioLabel">
							실험군
						</label>
					</div>
				</div>
				<div className="formModalItem__input">
					<div className="formModalItem__input__radio formModalItem__input__radio_limit_width120">
						<input
							type="radio"
							id="대조군"
							value="COMP"
							name="patient-group"
							checked={newPatientGroup === 'COMP'}
							onChange={e => setNewPatientGroup(e.target.value)}
							disabled={newPatientType==='PR'}
						/>{' '}
						<label htmlFor="대조군" className="formModalItem__input__radioLabel">
						대조군
						</label>
					</div>
				</div>
				<div className="formModalItem__input">
					<div className="formModalItem__input__radio formModalItem__input__radio_limit_width120">
						<input
							type="radio"
							id="테스터"
							value="TESTER"
							name="patient-type"
							checked={newPatientGroup === 'TESTER'}
							onChange={e => setNewPatientGroup(e.target.value)}
						/>{' '}
						<label htmlFor="테스터" className="formModalItem__input__radioLabel">
							테스터
						</label>
					</div>
				</div>
				<div className="formModalItem__input">
					<div className="formModalItem__input__radio formModalItem__input__radio_limit_width120">
						<input
							type="radio"
							id="일반"
							value="COMMON"
							name="patient-type"
							checked={newPatientGroup === 'COMMON'}
							onChange={e => setNewPatientGroup(e.target.value)}
							disabled={newPatientType==='EC' || newPatientType==='CC'}
						/>{' '}
						<label htmlFor="일반" className="formModalItem__input__radioLabel">
							일반
						</label>
					</div>
				</div>
			</div>
			<div className="formModalItem">
				<div className="formModalItem__label">이름</div>
				<div className="formModalItem__input">
					<input
						type="text"
						className="formModalItem__input__plainText"
						placeholder="이름"
						value={newPatientDisplayName}
						onChange={e => setNewPatientDisplayName(e.target.value)}
					/>
				</div>
			</div>
			<div className="formModalItem">
				<div className="formModalItem__label">휴대폰 번호</div>
				<div className="formModalItem__input">
					<input
						type="text"
						className="formModalItem__input__phoneNumber"
						value={patientData.phoneNumber ? patientData.phoneNumber.slice(0,3) : ""}
						size={3}
						maxLength={3}
						readOnly
						disabled
						style={{opacity: 0.5}}
					/>
					<span className="phoneDivider">-</span>
					<input
						type="text"
						className="formModalItem__input__phoneNumber"
						value={patientData.phoneNumber ? patientData.phoneNumber.slice(3,-4) : ""}
						size={4}
						maxLength={4}
						readOnly
						disabled
						style={{opacity: 0.5}}
					/>
					<span className="phoneDivider">-</span>
					<input
						type="text"
						className="formModalItem__input__phoneNumber"
						value={patientData.phoneNumber ? patientData.phoneNumber.slice(-4) : ""}
						size={4}
						maxLength={4}
						readOnly
						disabled
						style={{opacity: 0.5}}
					/>
				</div>
			</div>			
			<div className="formModalItem">
				<div className="formModalItem__label">생년월일</div>
				<div className="formModalItem__input">
					<select
						className="formModalItem__input__birth"
						onChange={e => setNewPatientBirthYear(e.target.selectedOptions[0].value)}
						value={newPatientBirthYear}
					>
						{birthYear()}
					</select>
					<span className="birthText">년</span>
					<select
						className="formModalItem__input__birth"
						onChange={e => setNewPatientBirthMonth(e.target.selectedOptions[0].value)}
						value={newPatientBirthMonth}
					>
						{birthMonth()}
					</select>
					<span className="birthText">월</span>
					<select
						className="formModalItem__input__birth"
						onChange={e => setNewPatientBirthDay(e.target.selectedOptions[0].value)}
						value={newPatientBirthDay}
					>
						{birthDay()}
					</select>
					<span className="birthText">일</span>
				</div>
			</div>			
			<div className="formModalItem">
				<div className="formModalItem__label">의료진 코드</div>
				<div className="formModalItem__input">
					<input
						type="text"
						className="formModalItem__input__plainTextWithButton"
						placeholder="의료진 코드"
						value={patientData.psctCode}
						readOnly
						disabled
						style={{opacity: 0.5}}
					/>
				</div>
			</div>
		</div>
	);

	const ModifyPatientModalFooter = (
		<div className="modalfooter">
			<button
				className="submitButton__rounded"
				onClick={modifyPatient}
				disabled={!(newPatientDisplayName && newPatientType && newPatientGroup)}
			>
				저장
			</button>
			<button className="cancelButton__rounded" onClick={closeModifyPatientModal}>
				취소
			</button>
		</div>
	);

	// 환자 수정 성공 modal
	const closeSuccessModifyPatientModal = () => {
		setShowSuccessModifyPatient(false);
		getPatienDataFromAPI();		
	}

	const SuccessModifyPatientModalBody = <div className="modalbody">정상적으로 환자가 수정되었습니다.</div>;

	const SuccessModifyPatientModalFooter = (
		<div className="modalfooter">
			<button
				className="submitButton__rounded"
				onClick={closeSuccessModifyPatientModal}
				style={{ width: '100%' }}
			>
				확인
			</button>
		</div>
	);

	// 메시지 전송 성공 모달 ----------------------------
	const [showSuccessSendMessageModal, setShowSuccessSendMessageModal] = useState(false);

	// 환자 수정 성공 modal
	const closeSuccessSendMessageModal = () => {
		setShowSuccessSendMessageModal(false);
	}

	const SuccessSendMessageModalBody = <div className="modalbody">메시지가 전송되었습니다.</div>;

	const SuccessSendMessageModalFooter = (
		<div className="modalfooter">
			<button
				className="submitButton__rounded"
				onClick={closeSuccessSendMessageModal}
				style={{ width: '100%' }}
			>
				확인
			</button>
		</div>
	);


	// 메시지 모달 ----------------------------
	const [openSendMessageModal, setOpenSendMessageModal] = useState(false);

	const [message, setMessage] = useState("");

	// // 0은 선택 안 한 상태
	const [selectedMessageTemplate, setSelectedMessageTemplate] = useState(0);

	const [messageTemplateData, setMessageTemplateData] = useState([]);

	// 간편 문구 조회 from API
	async function getMessageTemplateFromAPI() {
		try{
			const res = await getMessagesTemplateFromMomthera();
			if(Math.floor(res.status/100)===2){
				setMessageTemplateData(res.data);
			}else{
				setMessageTemplateData([]);
			}
		}catch{
			setMessageTemplateData([]);
		}
	}

	const handleClickMessageTemplate = (targetId) => {
		if(selectedMessageTemplate===targetId){
			setSelectedMessageTemplate(0);
			setMessage("")
		}else{
			setSelectedMessageTemplate(targetId);
			setMessage(messageTemplateData.filter(e=>e.templateCode===targetId)[0].templateContent);
		}
	}

	const showSendMessageModal = () => {
		setOpenSendMessageModal(true);
	}

	const closeSendMessageModal = () => {
		setOpenSendMessageModal(false);
		setSelectedMessageTemplate(0);
		setMessage("");
	}

	const SendMessageModalBody = (
		<div className="modalbody">
			<div className="formModalItem" style={{flexDirection: 'column'}}>
				<div className="momthera_sendMessageModalBody_label">간편 문구</div>
				<div className="momthera_sendMessageModalBody_templateBox">
					<span>간편 문구를 선택해서 메시지를 전송하거나 수정 후 전송할 수 있어요.</span>
					<div className='momthera_momthera_sendMessageModalBody_templateItem_wrapper'>
						{messageTemplateData.map(item => (
							<div key={item.templateCode}className='momthera_momthera_sendMessageModalBody_templateBox_templateItem'>
								<input
									type='radio'
									id={`message-template-${item.templateCode}`}
									onClick={()=>handleClickMessageTemplate(item.templateCode)}
									checked={selectedMessageTemplate===item.templateCode}
									readOnly
								/>
								<label htmlFor={`message-template-${item.templateCode}`}>{item.templateContent}</label>
							</div>
						))}
					</div>
				</div>
			</div>
			<div className="formModalItem" style={{flexDirection: 'column'}}>
				<div className="momthera_sendMessageModalBody_label">내용</div>
				<div className="momthera_sendMessageModalBody_input">
					<textarea
						type="text"
						className="formModalItem__input__textarea"
						placeholder="내용을 입력해주세요."
						value={message}
						onChange={e => setMessage(e.target.value)}
						style={{ height: '13.125rem', width: '100%' }}
					/>
				</div>
			</div>
		</div>
	)

	async function sendMessage () {
		if(!message) return;

		try{
			const request = {
				pid,
				name: patientData.name,
				phoneNumber: patientData.phoneNumber,
				message
			}
			const res = await postMessageToMomthera(request);
			if(parseInt(res.status/200,10)===1){
				console.log(res.data);
				setShowSuccessSendMessageModal(true);
			}else{
				alert("메시지 전송에 실패하였습니다.");
			}
		}catch(err){
			console.error(err);
			alert("메시지 전송에 실패하였습니다.");
		}finally{
			closeSendMessageModal();
		}
	} 

	const SendMessageModalFooter = (
		<div className="modalfooter">
			<button className="submitButton__rounded" onClick={sendMessage} disabled={!message}>
				전송
			</button>
			<button className="cancelButton__rounded" onClick={closeSendMessageModal}>
				취소
			</button>
		</div>
	);

	// 감정 기록지 조회
	async function getEmotionRecordsFromMomtheraAPI() {
		try{
			const res = await getEmotionRecordsFromMomthera({pid});
			if(Math.floor(res.status/100)===2 && res.data.length>0){
				setEmotionData(res.data);
			}else{
				setEmotionData(null);
			}
		}catch{
			setEmotionData(null);
		}
	}

	// 우울 점수 조회
	async function getSurveyDepressionResultFromAPI(){
		try{
			const res = await getSurveyDepressionResultFromMomthera({pid});
			if(Math.floor(res.status/100)===2 && res.data.length>0){
				setDepressionData(res.data)
			}else{
				setDepressionData([]);
			}
		}catch{
			setDepressionData([]);
		}
	}

	// 불안 점수 조회
	async function getSurveyAnxietyResultFromAPI(){
		try{
			const res = await getSurveyAnxietyResultFromMomthera({pid});
			if(Math.floor(res.status/100)===2 && res.data.length>0){
				setAnxietyData(res.data)
			}else{
				setAnxietyData([]);
			}
		}catch{
			setAnxietyData([]);
		}
	}

	useEffect(()=>{
		getMessageTemplateFromAPI();
	},[])

	useEffect(()=>{
		getPatienDataFromAPI();
		
		getEmotionRecordsFromMomtheraAPI();
		getSurveyDepressionResultFromAPI();
		getSurveyAnxietyResultFromAPI();
	},[pid])


	useEffect(()=>{
		initializeModifyModal(patientData);
	},[patientData])

	return (
		<div className="dashboardContent dtx006">
			<div className="dashboardContent__title">
				<span className="dashboardContent__title__content">환자 관리 {'>'} 환자 상세 페이지</span>
			</div>
			<div className="dashboardContent__inner">
				<div className="patientManageDetail momthera" style={{height: 'auto'}}>
					<MomtheraPatientDataSidebar
						emotionData={emotionData}
						depressionData={depressionData}
						anxietyData={anxietyData}
						patientData={patientData}
						showModifyPatientModal={()=>setShowModifyPatientModal(true)}
						showSendMessageModal={showSendMessageModal}
					/>
					<MomtheraPatientReport
						patientData={patientData}
						emotionData={emotionData}
						depressionData={depressionData}
						anxietyData={anxietyData}
					/>
				</div>
			</div>
			<CommonModal
				header="메시지 전송하기"
				body={SendMessageModalBody}
				footer={SendMessageModalFooter}
				show={openSendMessageModal}
				setClose={closeSendMessageModal}
				size="lg"
			/>
			<CommonModal
				header="환자 수정"
				body={ModifyPatientModalBody}
				footer={ModifyPatientModalFooter}
				show={showModifyPatientModal}
				setClose={closeModifyPatientModal}
				size="lg"
			/>
			<CommonModal
				header="환자 수정"
				body={SuccessModifyPatientModalBody}
				footer={SuccessModifyPatientModalFooter}
				show={showSuccessModifyPatient}
				setClose={closeSuccessModifyPatientModal}
				size="sm"
			/>
			<CommonModal
				header="메시지 전송하기"
				body={SuccessSendMessageModalBody}
				footer={SuccessSendMessageModalFooter}
				show={showSuccessSendMessageModal}
				setClose={closeSuccessSendMessageModal}
				size="sm"
			/>
		</div>
	);
}

export default MomtheraPatientManageDetailPage;
